import { Box, Button, FormControl, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import ColorPicker from "material-ui-color-picker";
import { useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import { Axios } from "../../App";
import styles from "./EventForm.styles";
import * as FaIcons from "react-icons/fa";

type TProps = {
  data?: any
}

const EventForm:React.FC<TProps> = ({ data }) => {
  const navigate = useNavigate();
  const alert = useAlert();

  const [formData, setFormData] = useState({
    name: "",
    logo: "",
    backgroundColor: "",
    fontColor: "",
  });

  useEffect(() => {
    const defaultFormData = {
      name: "",
      logo: "",
      backgroundColor: "#dddddd",
      fontColor: "#000",
    };
    setFormData(data ? {...data} : defaultFormData);
  }, [data]);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
  
    if (!file) {
      return alert.error("Nincs kép csatolva.");
    }
  
    if (file.size > 2 * 1024 * 1024) {
      return alert.error("A kép mérete nem lehet 2 MB-nál nagyobb.");
    }
  
    const { name } = event.target;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = ({ target }) => setFormData({ ...formData, [name]: target?.result });
  };
  
  const saveEvent = async (data: any, onSuccess: () => void) => {
    try {
      const url = data ? "events/updateEvent.php" : "events/createNew.php";
      const response = await Axios.post(url, {
        id: data?.id,
        name: formData.name,
        logo: formData.logo,
        background_color: formData.backgroundColor,
        font_color: formData.fontColor,
      });
  
      if (response?.data?.success) {
        alert.success("Mentve!");
        onSuccess();
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      alert.error("Valami nem stimmel.");
    }
  };
  
  const submitForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    saveEvent(data, () => navigate("/event-manager"));
  };

  return (
    <>
      <form>
        <FormControl style={styles.formControl}>
          <TextField
            id="name"
            name="name"
            type="text"
            label="Esemény neve"
            placeholder="Esemény neve"
            variant="outlined"
            onChange={onChangeInput}
            value={formData.name}
            required
          />
        </FormControl>

        <Box sx={styles.colorContainer}>
          <FormControl sx={[styles.formControl, styles.colorFormControl]}>
            <ColorPicker
              name="color"
              defaultValue="#dddddd"
              value={formData.backgroundColor}
              floatingLabelText="Háttér szín"
              onChange={(color) =>
                setFormData({
                  ...formData,
                  "backgroundColor": color,
                })
              }
            />
          </FormControl>
          <FormControl sx={[styles.formControl, styles.colorFormControl]}>
            <ColorPicker
              name="color"
              defaultValue="#000"
              value={formData.fontColor}
              floatingLabelText="Font szín"
              onChange={(color) =>
                setFormData({
                  ...formData,
                  "fontColor": color,
                })
              }
            />
          </FormControl>
        </Box>

        <Box sx={styles.logoContainer}>
          <FormControl sx={[styles.formControl, styles.logoFormControl]}>
            <Button
              variant="contained"
              component="label"
              size="small"
              sx={styles.button}
              startIcon={<FaIcons.FaImage size={10} />}
            >
              Logó feltöltés
              <input
                id="logo"
                name="logo"
                type="file"
                hidden
                onChange={onChangeFile}
                accept=".jpeg, .png, .jpg"
              />
            </Button>
          </FormControl>
          {formData.logo && 
            <img src={formData.logo} width="100px" height="auto" alt="logo" />
          }
        </Box>

        <Button
          size="medium"
          onClick={submitForm}
          disabled={!formData.name}
          variant="contained"
          color="primary"
          fullWidth
          sx={styles.button}
          startIcon={<FaIcons.FaSave size={10} />}
        >
          Mentés
        </Button>
      </form>
    </>
  );
};

export default React.memo(EventForm);
